import React, { Component } from 'react'
import style from './Key.scss'

class KeyCap extends Component {
  constructor(props) {
    super(props)
    this.state = { ...this.props }
  }
  render() {
    return (
      <div
        className={
          style[
            this.props.keyData.group
              ? `key--${this.props.keyData.group}`
              : `key`
          ]
        }
        data-size={this.props.keyData.size}
        style={{
          backgroundColor: this.props.theme[`${this.props.keyData.group}`].color
        }}
      >
        <span
          style={{
            color: this.props.theme[`${this.props.keyData.group}`].legend
          }}
        >
          {this.props.keyData.legends[this.props.legendSet]}
        </span>
      </div>
    )
  }
}

export default KeyCap



// WEBPACK FOOTER //
// ./src/components/Key/Key.js